import { IAdjustmentRuleStoreSegment } from './adjustmentRule.interface';

export const adjustmentRuleStoreSelector = (state: IAdjustmentRuleStoreSegment) => state.adjustmentRule;
